// ============================================================================
// ENUM LOOKUP ENDPOINTS
// ============================================================================

import { buildEndpointWithParams } from './base.endpoints';

const BASE_PATH = '/Enum';

export const enumEndpoints = {
  /** GET /api/v1/Enum/{group} — active entries of one enum group. */
  byGroup: (group: string) =>
    buildEndpointWithParams(`${BASE_PATH}/:group`, { group }),
} as const;

export default enumEndpoints;
